export default __webpack_public_path__ + "static/media/sequencing.3e121ae6.gif";